import classnames from 'classnames';
import React, { forwardRef, useState, useEffect, useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import { ButtonLooks } from '../../../../enums/button.js';
import { LoaderSizes } from '../../../../enums/loader.js';
import '../../../../styles/styled-components/alert.js';
import '../../../../styles/styled-components/animations.js';
import '../../../../styles/styled-components/box-shadow.js';
import { baseButtonStyle, getButtonTheme, getButtonWidth } from '../../../../styles/styled-components/button.js';
import '../../../../themes/alert.js';
import '../../../../themes/button.js';
import '../../../../themes/checkbox.js';
import '../../../../themes/divider.js';
import '../../../../themes/dropdown.js';
import '../../../../themes/fieldset.js';
import '../../../../themes/input.js';
import '../../../../themes/list.js';
import '../../../../themes/listbox.js';
import { getLoaderLookFromButtonLook } from '../../../../themes/loader.js';
import '../../../../themes/option.js';
import '../../../../themes/popout.js';
import '../../../../themes/switch.js';
import { lightTheme } from '../../../../themes/themes.js';
import '../../../../themes/tooltip.js';
import '../../../../styles/styled-components/font-face.js';
import '../../../../styles/styled-components/global.js';
import '../../../../styles/styled-components/input.js';
import '../../../../styles/styled-components/list.js';
import '../../../../styles/styled-components/listitem.js';
import '../../../../styles/styled-components/media-queries.js';
import '../../../../styles/styled-components/reset.js';
import '../../../../styles/styled-components/outline.js';
import '../../../../styles/styled-components/popout.js';
import '../../../../styles/styled-components/screen-reader.js';
import '../../../../styles/styled-components/switch.js';
import '../../../../styles/styled-components/tooltip.js';
import { FontIcon } from '../../icon/font-icon/font-icon.js';
import { CircleLoader } from '../../loader/circle-loader/circle-loader.js';
import '../../loader/shimmer-loader/shimmer-loader.js';
import { BaseLink } from '../base-link/base-link.js';

const BaseButtonLink = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { afterIconRight, children, childrenWrapperProps, className, count, countProps, disabled, endIcon, endIconProps, fullWidth, loaderLabel, loaderProps, loading, look, size, startIcon, startIconProps, ...otherProps } = props;
    const [loaderLook, setLoaderLook] = useState(getLoaderLookFromButtonLook(look));
    useEffect(()=>{
        setLoaderLook(getLoaderLookFromButtonLook(look));
    }, [
        loading,
        look
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ React.createElement(BaseLink, {
        ...otherProps,
        className: classnames({
            'bf-link__button': true,
            'bf-link__button--disabled': disabled,
            'bf-link__button--full-width': fullWidth,
            [`bf-link__button--${look}`]: look,
            [`bf-link__button--${size}`]: !!size,
            [`${className}`]: className
        }),
        disabled: disabled,
        ref: ref
    }, loaderLabel && loading && /*#__PURE__*/ React.createElement(CircleLoader, {
        buttonLook: look,
        label: loaderLabel,
        look: loaderLook,
        size: LoaderSizes.Small,
        ...loaderProps,
        className: classnames({
            'bf-link__loader': true,
            [`${loaderProps?.className}`]: !!loaderProps?.className
        })
    }), startIcon && /*#__PURE__*/ React.createElement(FontIcon, {
        ...startIconProps,
        className: classnames({
            'bf-link__start-icon': true,
            [`${startIconProps?.className}`]: !!startIconProps?.className
        }),
        icon: startIcon
    }), /*#__PURE__*/ React.createElement("span", {
        ...childrenWrapperProps,
        className: classnames({
            'bf-link__children': true,
            [`${childrenWrapperProps?.className}`]: !!childrenWrapperProps?.className
        })
    }, children), endIcon && /*#__PURE__*/ React.createElement(FontIcon, {
        ...endIconProps,
        className: classnames({
            'bf-link__end-icon': true,
            [`${endIconProps?.className}`]: !!endIconProps?.className
        }),
        icon: endIcon
    }), count !== undefined && /*#__PURE__*/ React.createElement("span", {
        ...countProps,
        className: classnames({
            'bf-link__count': true,
            [`${countProps?.className}`]: !!countProps?.className
        })
    }, count), afterIconRight && /*#__PURE__*/ React.createElement("span", null, afterIconRight));
});
const Link = styled(BaseButtonLink)`
  ${baseButtonStyle}
  ${({ look })=>getButtonTheme({
        look
    })}
  ${({ fullWidth, size })=>getButtonWidth({
        fullWidth,
        size
    })}

  .bf-icon {
    font-size: 14px;
  }

  .bf-link__end-icon {
    margin-inline-start: 10px;
  }

  .bf-link__start-icon {
    margin-inline-end: 10px;
  }

  .bf-link__loader {
    margin-inline-end: 10px;
  }

  .bf-loader__circle {
    width: auto;
  }

  .bf-link__count {
    margin-inline-start: 10px;
  }
`;
const ButtonLink = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { fullWidth = false, loading = false, look = ButtonLooks.Primary, ...otherProps } = props;
    const themeContext = useContext(ThemeContext);
    return /*#__PURE__*/ React.createElement(ThemeProvider, {
        theme: themeContext || lightTheme
    }, /*#__PURE__*/ React.createElement(Link, {
        ...otherProps,
        fullWidth: fullWidth,
        loading: loading,
        look: look,
        ref: ref
    }));
});

export { BaseButtonLink, ButtonLink };
//# sourceMappingURL=button-link.js.map
